var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgCamera = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0566 5.80851H20.4255C21.8474 5.80851 23 6.96114 23 8.38298V18.6809C23 20.1027 21.8474 21.2553 20.4255 21.2553H3.57447C2.15263 21.2553 1 20.1027 1 18.6809V8.38298C1 6.96114 2.15263 5.80851 3.57447 5.80851H6.94338L8.60728 3.31266C8.7375 3.11733 8.95673 3 9.19149 3H14.8085C15.0433 3 15.2625 3.11733 15.3927 3.31266L17.0566 5.80851ZM9.56726 4.40503L7.90335 6.90088C7.77313 7.09621 7.55391 7.21354 7.31915 7.21354H3.57447C2.92818 7.21354 2.40426 7.73746 2.40426 8.38375V18.6816C2.40426 19.3279 2.92818 19.8518 3.57447 19.8518H20.4255C21.0718 19.8518 21.5957 19.3279 21.5957 18.6816V8.38375C21.5957 7.73746 21.0718 7.21354 20.4255 7.21354H16.6809C16.4461 7.21354 16.2269 7.09621 16.0966 6.90088L14.4327 4.40503H9.56726ZM12 17.5106C9.5441 17.5106 7.55319 15.5197 7.55319 13.0638C7.55319 10.6079 9.5441 8.61702 12 8.61702C14.4559 8.61702 16.4468 10.6079 16.4468 13.0638C16.4468 15.5197 14.4559 17.5106 12 17.5106ZM12 16.1064C13.6804 16.1064 15.0426 14.7442 15.0426 13.0638C15.0426 11.3835 13.6804 10.0213 12 10.0213C10.3196 10.0213 8.95745 11.3835 8.95745 13.0638C8.95745 14.7442 10.3196 16.1064 12 16.1064Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgCamera;